import {GraphQLService} from "./graphql.service";
import {Category} from "../models/category.model";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable()
export class CategoryService extends GraphQLService<Category> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  fetchCategory(id?: number, locale?: string): Observable<Category> {
    return this.find(`{ category(id: ${id}, iso: "${locale}") { categoryTokens { value } } }`)
  }

  fetchCategories(id?: number, locale?: string): Observable<Category[]> {
    if (id && id !== 0) {
      return this.findAll(`{categories(id: ${id}, iso: "${locale}") { id productCount categoryTokens { value } children { id productCount categoryTokens { value } } ancestors { id productCount categoryTokens { value }}}}`)
    } else {
      return this.findAll(`{categories(iso: "${locale}") { id productCount categoryTokens { value } }}`)
    }
  }

}
